import styled from "styled-components"

const Wrapper = styled.section`
  padding: 1rem 0 4rem 0;
`

export default Wrapper
